import React from "react";
import { Outlet, useLocation } from 'react-router-dom';
import { motion } from "framer-motion";

const PageLayout = ({ children }) => children;

const AnimationLayout = () => {
  const pageVariants = {
    initial: {
      opacity: 0
    },
    in: {
      opacity: 1
    },
    out: {
      opacity: 0
    }
  };
  
  const pageTransition = {
    type: "tween",
    ease: "linear",
    duration: 0.7
  };

  const { pathname } = useLocation();
  return (
    <PageLayout>
      <motion.div
        className='motion-holder'
        key={pathname}
        initial="initial"
        animate="in"
        variants={pageVariants}
        transition={pageTransition}
      >
        <Outlet />
      </motion.div>
    </PageLayout>
  );
};

export default AnimationLayout;